import React, { useState, useMemo } from 'react';
import { Search } from 'lucide-react';

export const ProductTable = ({ columns = [], rows = [] }) => {
  const [query, setQuery] = useState('');

  const keys = useMemo(() => {
    if (columns.length === 4) return ['product', 'ionic', 'application', 'description'];
    return ['product', 'description'];
  }, [columns]);

  const filtered = useMemo(() => {
    if (!query.trim()) return rows;
    const q = query.toLowerCase();
    return rows.filter((r) => keys.some((k) => (r[k] || '').toLowerCase().includes(q)));
  }, [rows, query, keys]);

  return (
    <div>
      <div className="relative max-w-md mb-6">
        <Search className="absolute left-3.5 top-1/2 -translate-y-1/2 h-4 w-4 text-black/40" />
        <input
          data-testid="product-table-search-input"
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          placeholder="Search products..."
          className="w-full h-11 rounded-lg bg-white border border-[#E6E8EE] pl-10 pr-4 text-sm focus:outline-none focus:ring-2 focus:ring-[#26247B]"
        />
      </div>

      <div className="overflow-x-auto rounded-xl border border-[#E6E8EE] shadow-[0_8px_20px_rgba(17,24,39,0.06)]">
        <table data-testid="product-table" className="w-full text-left border-collapse bg-white">
          <thead>
            <tr className="bg-[#26247B]">
              {columns.map((c) => (
                <th key={c} className="px-5 py-4 text-white text-sm font-bold whitespace-nowrap">{c}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {filtered.map((row, i) => (
              <tr key={i} className={i % 2 === 0 ? 'bg-white' : 'bg-[#F6F7F9]'}>
                <td className="px-5 py-3.5 text-sm font-bold text-[#26247B] whitespace-nowrap align-top">{row.product}</td>
                {keys.includes('ionic') && <td className="px-5 py-3.5 text-sm text-black/80 whitespace-nowrap align-top">{row.ionic}</td>}
                {keys.includes('application') && <td className="px-5 py-3.5 text-sm text-black/80 whitespace-nowrap align-top">{row.application}</td>}
                <td className="px-5 py-3.5 text-sm text-black/80 leading-6 align-top">{row.description}</td>
              </tr>
            ))}
            {filtered.length === 0 && (
              <tr>
                <td colSpan={columns.length} className="px-5 py-10 text-center text-black/60 text-sm">
                  No products match your search.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      <p className="mt-3 text-xs text-black/50">{filtered.length} of {rows.length} products shown</p>
    </div>
  );
};
